import React from 'react';
import { useSelector } from 'react-redux';
import Sidebar from '../../components/admin/Sidebar';

const AdminLayout = ({ children }) => {
  const auth = useSelector((state) => state.auth);

  return (
    <div className="admin-layout">
      <Sidebar />
      <main className="admin-layout__content">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;